import { formatFolderName } from '@/lib/folderName';

const FolderName = ({ name }: { name: string }) => {
  const parsedName = formatFolderName(name);
  return <>{parsedName}</>;
};

export default FolderName;
